import { Component } from 'react';
import PropTypes from 'prop-types';
import { JWTOKEN, AUTHORIZATION_REQUEST_HANDLE_KEY, ACCESS_TOKEN } from './../../data/constants';
import { login } from '../../settings/settings.json';

class TokenGuard extends Component {
  componentDidMount() {
    this.tokenExists = false;
    this.readToken();
  }
  readToken = () => {
    if (login.authType === 'OIDC') {
      if (!(sessionStorage.getItem(AUTHORIZATION_REQUEST_HANDLE_KEY) || sessionStorage.getItem(ACCESS_TOKEN))) {
        this.props.redirect('/login');
      }
      if (sessionStorage.getItem(ACCESS_TOKEN)) {
        this.tokenExists = true;
      }
      if (sessionStorage.getItem(AUTHORIZATION_REQUEST_HANDLE_KEY)) {
        this.props.redirect('/login');
      }
    } else { // default authentication type. TokenGuard does not handle MSAL authentication
      const jwToken = sessionStorage.getItem(JWTOKEN);
      this.tokenExists = Boolean(jwToken);
      if (!this.tokenExists) {
        this.props.redirect('/login');
      }
    }
  }
  render() {
    if (!this.tokenExists) {
      return null;
    }

    return this.props.children;
  }
}

TokenGuard.propTypes = {
  children: PropTypes.node.isRequired,
  redirect: PropTypes.func.isRequired,
};

export default TokenGuard;
